(function ($) {
    $(document).ready(function () {
        $('.c-contentslider.main-slider').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 2500,
            mobileFirst: true,
            infinite: true,
            arrows: false,
            pauseOnFocus: false,
        });

        $('.boxslider').slick({
            autoplay: false,
            mobileFirst: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false,

            prevArrow: '<a href="javascript:void(0)" class="slick-prev"><img class="slick-arrow--left" src="/files/theme/lpr/img/arrow.png"/></a>',
            nextArrow: '<a href="javascript:void(0)" class="slick-next"><img class="slick-arrow--right" src="/files/theme/lpr/img/arrow.png"/></a>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        arrows: true,
                    }
                },

            ]
        });

        $('.tabbox__inner').slick({
            dots: false,
            autoplay: false,
            mobileFirst: false,
            infinite: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.tabbox__title',
        });
        $('.tabbox__title').slick({
            dots: false,
            autoplay: false,
            mobileFirst: false,
            infinite: false,
            arrows: false,
            asNavFor: '.tabbox__inner',
            focusOnSelect: true,
            /* responsive: [
             {
             breakpoint: 768,
             settings: {
             slidesToShow: 1,
             slidesToScroll: 1,
             }
             },

             ]*/
        });
    });
})
(jQuery);